import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../api";

// Оставляем маску для отображения
function formatPhoneNumber(value) {
    let digits = value.replace(/\D/g, "");
    if (digits.length > 0 && digits[0] !== "7") digits = "7" + digits.slice(1);
    digits = digits.slice(0, 11);
    let formatted = "+7";
    if (digits.length > 1) formatted += " (" + digits.slice(1, 4);
    if (digits.length >= 4) formatted += ") " + digits.slice(4, 7);
    if (digits.length >= 7) formatted += "-" + digits.slice(7, 9);
    if (digits.length >= 9) formatted += "-" + digits.slice(9, 11);
    return formatted;
}

export default function ForgotPasswordScreen() {
    const [phone, setPhone] = useState("+7");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleRecover = async () => {
        // БЕЗ ОЧИСТКИ – отправляем прямо как в поле ввода
        const rawPhone = phone;
        if (rawPhone.length < 10) {
            // минимальная проверка на заполненность
            alert("Введите номер телефона");
            return;
        }

        setLoading(true);
        try {
            const response = await authAPI.forgotPassword(rawPhone);
            if (response.status === 201) {
                alert("Новый пароль отправлен в бот");
                navigate("/login");
            } else {
                alert(response.data?.message || "Не удалось отправить запрос");
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message || "Проверьте подключение к интернету";
            alert(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
            <div className="w-full max-w-sm">
                <h1 className="text-3xl font-bold text-gray-800 mb-2 text-center">Восстановление пароля</h1>
                <p className="text-gray-500 text-center mb-8">Введите номер телефона, и мы отправим новый пароль</p>

                <div className="mb-6">
                    <label className="text-gray-700 mb-1 ml-1 block">Телефон</label>
                    <input
                        className="bg-white p-4 rounded-xl border border-gray-200 w-full text-base"
                        placeholder="+7 (999) 999-99-99"
                        value={phone}
                        onChange={(e) => setPhone(formatPhoneNumber(e.target.value))}
                        type="tel"
                        disabled={loading}
                    />
                </div>

                <button onClick={handleRecover} disabled={loading} className={`w-full py-4 rounded-xl text-white font-bold text-lg ${loading ? "bg-blue-300" : "bg-blue-500"}`}>
                    {loading ? "Отправка..." : "Восстановить"}
                </button>

                <button onClick={() => navigate("/login")} className="w-full mt-4 text-blue-500 text-center">
                    Вернуться ко входу
                </button>
            </div>
        </div>
    );
}
